import { render, staticRenderFns } from "./loginHeader.vue?vue&type=template&id=f715d5c6&scoped=true&"
import script from "./loginHeader.vue?vue&type=script&lang=js&"
export * from "./loginHeader.vue?vue&type=script&lang=js&"
import style0 from "./loginHeader.vue?vue&type=style&index=0&id=f715d5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f715d5c6",
  null
  
)

export default component.exports